var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgWithoutProjectsFollowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mis-Proyectos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Proyectos/cards-Empty",
    transform: "translate(-601.000000, -443.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(426.000000, 203.566271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_SigueProyectos",
    transform: "translate(175.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.433729)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E7EDF7",
    cx: 10.5,
    cy: 10.7777778,
    rx: 10.5,
    ry: 10.1111111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,6.22222222 C14.8970769,6.22222222 17.7692308,10.7097643 17.7692308,10.7097643 C17.7692308,10.7097643 14.8970769,15.1973064 10.5,15.1973064 C6.10292308,15.1973064 3.23076923,10.7097643 3.23076923,10.7097643 C3.23076923,10.7097643 6.10292308,6.22222222 10.5,6.22222222 Z M10.5,7.5043771 C8.715,7.5043771 7.26923077,8.93878788 7.26923077,10.7097643 C7.26923077,12.4807407 8.715,13.9151515 10.5,13.9151515 C12.285,13.9151515 13.7307692,12.4807407 13.7307692,10.7097643 C13.7307692,8.93878788 12.285,7.5043771 10.5,7.5043771 Z",
    id: "Combined-Shape",
    fill: "#515459",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,8.94680135 C11.4821538,8.94680135 12.2769231,9.7353266 12.2769231,10.7097643 C12.2769231,11.684202 11.4821538,12.4727273 10.5,12.4727273 C9.51946154,12.4727273 8.72307692,11.684202 8.72307692,10.7097643 C8.72307692,9.7353266 9.51784615,8.94680135 10.5,8.94680135 C10.5,8.94680135 10.5,8.94680135 10.5,8.94680135 Z",
    fill: "#515459",
    fillRule: "nonzero"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgWithoutProjectsFollowIcon);
export default __webpack_public_path__ + "static/media/bg-without-projects-follow-icon.bf87958e.svg";
export { ForwardRef as ReactComponent };